import React from 'react'
import { Global } from '@emotion/react'

const Fonts = () => (
  <Global
    styles={`
      @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500&family=Montserrat:wght@500;700&family=Nunito:wght@500;700&family=Poppins:wght@500;700&display=swap');
      @import url('https://fonts.cdnfonts.com/css/circular-std-book?styles=16171,16173,16169');
      @import url('https://fonts.cdnfonts.com/css/avenir');
      @import url('https://fonts.googleapis.com/css2?family=League+Spartan:wght@500;600;700&family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
      @import url('https://fonts.cdnfonts.com/css/ambit');
      @import url('https://fonts.cdnfonts.com/css/oscine-trial');

    `}
  />
)

/* Fuentes por directorio: 
- Reworth: DM+Sans , Montserrat, Nunito, Poppins
- BanCoppel : Circular
- Invex: Avenir
- Uniq(Metricas): Raleway
-Liverpool: Ambit
- Suburbia: Oscine

*/
export default Fonts
